import React, { useEffect, useState } from "react";
import PopupBookPanditForm from "./PopupBookPanditForm";

const BookPanditPopupModal = () => {

  const [selectedPujaId, setSelectedPujaId] = useState(null);

  useEffect(() => {

    const handleOpenModal = (event) => {

      const pujaId = event.detail?.pujaId || null;

      setSelectedPujaId(pujaId);

      const modal = new window.bootstrap.Modal(
        document.getElementById("bookPanditModal")
      );

      modal.show();
    };

    window.addEventListener(
      "openBookPanditModal",
      handleOpenModal
    );

    return () => {
      window.removeEventListener(
        "openBookPanditModal",
        handleOpenModal
      );
    };

  }, []);

  return (
    <div
      className="modal fade"
      id="bookPanditModal"
      tabIndex="-1"
    >
     <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">

          <div className="modal-header">
            <h5 className="modal-title">
              Book Pandit
            </h5>

            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
            />
          </div>

         <div
  className="modal-body p-0"
  style={{
    overflowX: "hidden"
  }}
>
  <PopupBookPanditForm
    selectedPujaId={selectedPujaId}
  />
</div>

        </div>
      </div>
    </div>
  );
};

export default BookPanditPopupModal;